import { render, staticRenderFns } from "./TitleWithPenSwitcher.vue?vue&type=template&id=587b9d0c&scoped=true&lang=pug&"
import script from "./TitleWithPenSwitcher.vue?vue&type=script&lang=ts&"
export * from "./TitleWithPenSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./TitleWithPenSwitcher.vue?vue&type=style&index=0&id=587b9d0c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587b9d0c",
  null
  
)

export default component.exports